import * as React from 'react';
import { Box, css, styled } from '@goodrx/matisse-react';
import cn from 'classnames';
import { HeyDoctorService } from '../../../HeyDoctorService';
import { mediaMaxWidth } from '../../../../utils';
const Grid = styled(Box)`
  & {
    display: flex;
    flex-wrap: wrap;
  }

  ${mediaMaxWidth({
  sm: css`
      & {
        flex-direction: column;
      }
    `
})}
`;
const ItemContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 36px;
  flex-grow: 1;
  width: 33%;
  flex-direction: column;

  ${mediaMaxWidth({
  sm: css`
      & {
        width: 100%;
        margin-bottom: 24px;
      }
    `
})}
`;
export const HeyDoctorServicesGallery = ({
  className,
  servicesCollection
}) => {
  return /*#__PURE__*/React.createElement(Grid, {
    className: cn(className, 'HeyDoctorServicesGalleryType')
  }, servicesCollection === null || servicesCollection === void 0 ? void 0 : servicesCollection.items.map(service => /*#__PURE__*/React.createElement(ItemContainer, {
    key: service.sys.id
  }, /*#__PURE__*/React.createElement(HeyDoctorService, service))));
};